export const formatTitleCase = (str) => {
  if (!str) return '';
  return String(str)
    .replace(/^\s+/, '') // Hapus spasi di awal
    .replace(/\s{2,}/g, ' ') // Ganti dua spasi atau lebih menjadi satu spasi
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
  // return str;
};

export const formatUpperCase = (str) => {
  if (!str) return '';
  return String(str)
    .replace(/^\s+/, '') // Hapus spasi di awal
    .replace(/\s{2,}/g, ' ') // Ganti dua spasi atau lebih menjadi satu spasi
    .toUpperCase();
  // return str;
};
